// import React, { useEffect, useState, useMemo } from "react";
// import axios from "axios";
// import {
//     BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend,
//     ResponsiveContainer, PieChart, Pie, Cell, LineChart, Line,
//     ComposedChart, AreaChart, Area
// } from "recharts";
// import {
//     TrendingUp, TrendingDown, DollarSign, ShoppingBag, Package,
//     Users, CreditCard, CheckCircle, Calculator,
//     Building, Tag, Truck, FileText, Utensils, Coffee, Pizza,
//     Cake, ShoppingCart, CalendarIcon, Target,
//     BarChart as BarChartIcon, PieChart as PieChartIcon,
//     AlertCircle, Shield, Activity, Scale, Wallet, ChevronDown,
//     Download, Filter, Sparkles, Crown, Trophy, TrendingUp as TrendUp,
//     RotateCcw, Star, Clock, PackageOpen, UserCheck,
//     MessageSquare, ThumbsUp, Award, CreditCard as CreditCardIcon,
//     Star as StarIcon, Percent, DollarSign as DollarSignIcon,
//     Pizza as PizzaIcon, ShoppingBag as ShoppingBagIcon,
//     Cake as CakeIcon, Coffee as CoffeeIcon
// } from 'lucide-react';

// const Revenue = ({ isMobile, colors, generateDateTrendData, generateOrderTypeData,
//     generateCategoryData, generateTopItemsData, generatePaymentData,
//     generateGrossNetData, generateDiscountImpactData, startDate, endDate }) => {

//     /* ---------------- STATE ---------------- */
//     const [stats, setStats] = useState(null);
//     const [loadingStats, setLoadingStats] = useState(false);
//     const [error, setError] = useState(null);

//     /* ---------------- API CALL ---------------- */
//     useEffect(() => {
//         const fetchRevenueData = async () => {
//             setLoadingStats(true);
//             setError(null);

//             try {
//                 const token = localStorage.getItem("authToken");
//                 if (!token) {
//                     throw new Error("No auth token found. Please login.");
//                 }

//                 const response = await axios.get(
//                     "https://backend.maamaas.com/food/api/orders/admin/statistics",
//                     {
//                         headers: {
//                             Authorization: `Bearer ${token}`,
//                             Accept: "application/json",
//                         },
//                     }
//                 );

//                 const apiData = response.data || {};
//                 console.log("Revenue API Response:", apiData);

//                 setStats(apiData);

//             } catch (err) {
//                 console.error("❌ Revenue API error:", err);
//                 setError(err.message || "Failed to fetch revenue data");
//                 // Set default empty stats
//                 setStats({
//                     totalRevenue: 0,
//                     todayRevenue: 0,
//                     totalOrders: 0,
//                     todayTotalOrders: 0,
//                     totalCustomers: 0,
//                     todayCustomers: 0,
//                     salesGrowth: "0%",
//                     newCustomers: 0,
//                     returningCustomers: 0,
//                     topPerformingVendors: [],
//                     paymentMethods: [],
//                     totalCancelledOrders: 0,
//                     todayCancelledOrders: 0,
//                     todaySuccessRate: "0%"
//                 });
//             } finally {
//                 setLoadingStats(false);
//             }
//         };

//         fetchRevenueData();
//     }, []);

//     // Summary Cards Component
//     const SummaryCards = () => {
//         const cards = [
//             {
//                 title: 'Total Revenue',
//                 value: `₹${(stats?.totalRevenue || 0).toLocaleString('en-IN', { 
//                     minimumFractionDigits: 2, 
//                     maximumFractionDigits: 2 
//                 })}`,
//                 icon: <span style={{ fontSize: '18px', fontWeight: '700' }}>₹</span>,
//                 color: colors?.success || "#10b981",
//                 bgColor: 'linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%)',
//                 subtitle: `${stats?.totalOrders || 0} total orders`
//             },
//             {
//                 title: "Today's Revenue",
//                 value: `₹${(stats?.todayRevenue || 0).toLocaleString('en-IN', { 
//                     minimumFractionDigits: 2, 
//                     maximumFractionDigits: 2 
//                 })}`,
//                 icon: <TrendingUp size={isMobile ? 16 : 18} />,
//                 color: colors?.primary || "#3b82f6",
//                 bgColor: 'linear-gradient(135deg, #ede9fe 0%, #ddd6fe 100%)',
//                 subtitle: `${stats?.todayTotalOrders || 0} orders today`
//             },
//             {
//                 title: 'Avg Order Value',
//                 value: `₹${stats?.totalOrders > 0 ? 
//                     Math.round((stats.totalRevenue || 0) / stats.totalOrders).toLocaleString('en-IN') : 
//                     "0"}`,
//                 icon: <Target size={isMobile ? 16 : 18} />,
//                 color: colors?.accent || "#f59e0b",
//                 bgColor: 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)',
//                 subtitle: `Sales growth: ${stats?.salesGrowth || "0%"}`
//             },
//             {
//                 title: 'Customers',
//                 value: (stats?.totalCustomers || 0).toLocaleString('en-IN'),
//                 icon: <Users size={isMobile ? 16 : 18} />,
//                 color: colors?.info || "#8b5cf6",
//                 bgColor: 'linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%)',
//                 subtitle: `${stats?.newCustomers || 0} new, ${stats?.returningCustomers || 0} returning`
//             }
//         ];

//         if (loadingStats) {
//             return (
//                 <div style={{ padding: 20, textAlign: "center", color: "#64748b" }}>
//                     Loading revenue summary...
//                 </div>
//             );
//         }

//         if (error && !stats) {
//             return (
//                 <div style={{ 
//                     padding: "20px", 
//                     textAlign: "center", 
//                     color: "#ef4444",
//                     background: "#fef2f2",
//                     borderRadius: "12px",
//                     marginBottom: "20px"
//                 }}>
//                     <h4 style={{ fontWeight: 600 }}>⚠️ Error Loading Data</h4>
//                     <p>{error}</p>
//                 </div>
//             );
//         }

//         return (
//             <div
//                 style={{
//                     display: 'grid',
//                     gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)',
//                     gap: isMobile ? '8px' : '12px',
//                     marginBottom: isMobile ? '16px' : '20px',
//                     marginTop: isMobile ? '-5px' : '-28px',
//                 }}
//             >
//                 {cards.map((card, index) => (
//                     <div
//                         key={index}
//                         style={{
//                             background: card.bgColor,
//                             borderRadius: '12px',
//                             padding: isMobile ? '12px' : '16px',
//                             boxShadow: '0 4px 12px rgba(0,0,0,0.04)',
//                             border: '1px solid white',
//                             position: 'relative'
//                         }}
//                     >
//                         <p
//                             style={{
//                                 fontSize: isMobile ? '10px' : '11px',
//                                 color: '#475569',
//                                 fontWeight: '600'
//                             }}
//                         >
//                             {card.title}
//                         </p>

//                         <div
//                             style={{
//                                 display: 'flex',
//                                 justifyContent: 'space-between',
//                                 alignItems: 'center'
//                             }}
//                         >
//                             <div>
//                                 <p
//                                     style={{
//                                         fontSize: isMobile ? '16px' : '20px',
//                                         fontWeight: '800',
//                                         color: '#1e293b',
//                                         marginBottom: '4px'
//                                     }}
//                                 >
//                                     {card.value}
//                                 </p>
//                                 {card.subtitle && (
//                                     <p style={{ fontSize: 10, color: "#64748b", margin: 0 }}>
//                                         {card.subtitle}
//                                     </p>
//                                 )}
//                             </div>

//                             <div
//                                 style={{
//                                     width: isMobile ? '32px' : '40px',
//                                     height: isMobile ? '32px' : '40px',
//                                     borderRadius: '10px',
//                                     background: 'rgba(255,255,255,0.6)',
//                                     display: 'flex',
//                                     alignItems: 'center',
//                                     justifyContent: 'center',
//                                     color: card.color
//                                 }}
//                             >
//                                 {card.icon}
//                             </div>
//                         </div>
//                     </div>
//                 ))}
//             </div>
//         );
//     };

//     // Date Trend Chart
//     const DateTrendChart = () => {
//         const dateTrendData = useMemo(() => {
//             if (!stats) return [];

//             // Create simulated trend data based on total revenue
//             const now = new Date();
//             const result = [];

//             // Create last 7 days data
//             for (let i = 6; i >= 0; i--) {
//                 const d = new Date(now.getFullYear(), now.getMonth(), now.getDate() - i);
//                 const dateStr = d.toLocaleDateString('en-IN', { 
//                     day: '2-digit', 
//                     month: 'short' 
//                 });

//                 // Generate realistic revenue based on today's revenue
//                 const baseRevenue = stats.todayRevenue || 20476.87;
//                 const dayFactor = 0.7 + (i / 7) * 0.6; // Increasing trend
//                 const randomFactor = 0.8 + Math.random() * 0.4;
//                 const revenue = Math.floor(baseRevenue * dayFactor * randomFactor);
//                 const netRevenue = revenue * 0.95; // Assuming 5% discount/expenses

//                 result.push({
//                     date: dateStr,
//                     revenue,
//                     netRevenue
//                 });
//             }

//             return result;
//         }, [stats]);

//         if (loadingStats) return <div>Loading trend chart...</div>;

//         return (
//             <div style={{
//                 background: 'white',
//                 borderRadius: '24px',
//                 padding: isMobile ? '20px' : '28px',
//                 marginBottom: isMobile ? '20px' : '28px',
//                 border: '1px solid #e2e8f0',
//                 boxShadow: '0 12px 32px rgba(0,0,0,0.05)'
//             }}>
//                 <h3 style={{ fontWeight: 800, marginBottom: 20 }}>
//                     7-Day Revenue Trend
//                 </h3>
//                 <ResponsiveContainer width="100%" height={300}>
//                     <LineChart data={dateTrendData}>
//                         <CartesianGrid strokeDasharray="3 3" />
//                         <XAxis dataKey="date" />
//                         <YAxis tickFormatter={(v) => `₹${(v/1000).toFixed(0)}K`} />
//                         <Tooltip formatter={(v) => `₹${v.toLocaleString("en-IN")}`} />
//                         <Legend />
//                         <Line 
//                             dataKey="revenue" 
//                             stroke={colors?.primary || "#3b82f6"} 
//                             strokeWidth={2}
//                             dot={{ r: 4 }}
//                         />
//                         <Line 
//                             dataKey="netRevenue" 
//                             stroke={colors?.success || "#10b981"} 
//                             strokeWidth={2}
//                             dot={{ r: 4 }}
//                         />
//                     </LineChart>
//                 </ResponsiveContainer>
//             </div>
//         );
//     };

//     // Order Type Chart
//     const OrderTypeChart = () => {
//         const orderTypeData = useMemo(() => {
//             // Since API doesn't provide order type data, we'll simulate based on revenue
//             const orderTypes = [
//                 { name: "Dine In", percentage: 35 },
//                 { name: "Takeaway", percentage: 30 },
//                 { name: "Delivery", percentage: 25 },
//                 { name: "Drive Thru", percentage: 10 }
//             ];

//             const totalRevenue = stats?.totalRevenue || 0;
//             const colorPalette = [
//                 "#6366f1",
//                 "#10b981",
//                 "#f59e0b",
//                 "#ef4444",
//                 "#3b82f6"
//             ];

//             return orderTypes.map((type, index) => ({
//                 name: type.name,
//                 revenue: Math.round((totalRevenue * type.percentage) / 100),
//                 percentage: type.percentage,
//                 color: colorPalette[index % colorPalette.length]
//             }));
//         }, [stats]);

//         // Calculate total revenue safely
//         const totalRevenue = orderTypeData.reduce((sum, item) => sum + (item.revenue || 0), 0);

//         // Find most popular safely
//         const mostPopularItem = orderTypeData.length > 0 
//             ? orderTypeData.reduce((a, b) => (a.revenue > b.revenue ? a : b))
//             : { name: "N/A", percentage: 0 };

//         // Find top share safely
//         const topShare = orderTypeData.length > 0 
//             ? Math.max(...orderTypeData.map(i => i.percentage || 0))
//             : 0;

//         if (loadingStats) return <div>Loading order type chart...</div>;

//         return (
//             <div style={{
//                 background: 'white',
//                 borderRadius: '24px',
//                 padding: isMobile ? '20px' : '28px',
//                 marginBottom: isMobile ? '20px' : '28px',
//                 border: '1px solid #e2e8f0',
//                 boxShadow: '0 12px 32px rgba(0,0,0,0.05)',
//                 position: 'relative'
//             }}>
//                 {/* TOP BORDER */}
//                 <div style={{
//                     position: 'absolute',
//                     top: 0,
//                     left: 0,
//                     right: 0,
//                     height: '4px',
//                     background: 'linear-gradient(135deg, #6366f1, #3b82f6)'
//                 }} />

//                 {/* HEADER */}
//                 <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 24 }}>
//                     <div style={{ display: 'flex', gap: 12 }}>
//                         <div style={{
//                             width: 48,
//                             height: 48,
//                             borderRadius: 12,
//                             background: 'linear-gradient(135deg, #6366f1, #3b82f6)',
//                             display: 'flex',
//                             alignItems: 'center',
//                             justifyContent: 'center',
//                             color: '#fff'
//                         }}>
//                             <ShoppingBag size={24} />
//                         </div>
//                         <div>
//                             <h3 style={{ fontSize: 22, fontWeight: 800 }}>
//                                 Order Type Distribution
//                             </h3>
//                             <p style={{ color: '#64748b' }}>
//                                 Revenue breakdown by order type
//                             </p>
//                         </div>
//                     </div>
//                 </div>

//                 {/* CHART */}
//                 <div style={{ height: isMobile ? 280 : 400 }}>
//                     <ResponsiveContainer width="100%" height="100%">
//                         <BarChart data={orderTypeData}>
//                             <CartesianGrid strokeDasharray="3 3" vertical={false} />
//                             <XAxis dataKey="name" />
//                             <YAxis tickFormatter={(v) => `₹${v.toLocaleString('en-IN')}`} />
//                             <Tooltip formatter={(v) => `₹${Number(v).toLocaleString('en-IN')}`} />
//                             <Legend />
//                             <Bar dataKey="revenue" radius={[8, 8, 0, 0]}>
//                                 {orderTypeData.map((entry, i) => (
//                                     <Cell key={i} fill={entry.color} />
//                                 ))}
//                             </Bar>
//                         </BarChart>
//                     </ResponsiveContainer>
//                 </div>

//                 {/* STATS */}
//                 <div style={{
//                     marginTop: 20,
//                     padding: 16,
//                     background: '#f8fafc',
//                     borderRadius: 16,
//                     border: '1px solid #e2e8f0'
//                 }}>
//                     <div style={{ display: 'flex', justifyContent: 'space-between' }}>
//                         <div>
//                             <div style={{ fontSize: 12, color: '#64748b' }}>Total Revenue</div>
//                             <div style={{ fontSize: 20, fontWeight: 800 }}>
//                                 ₹{totalRevenue.toLocaleString('en-IN')}
//                             </div>
//                         </div>
//                         <div>
//                             <div style={{ fontSize: 12, color: '#64748b' }}>Most Popular</div>
//                             <div style={{ fontWeight: 700 }}>
//                                 {mostPopularItem.name}
//                             </div>
//                         </div>
//                         <div>
//                             <div style={{ fontSize: 12, color: '#64748b' }}>Top Share</div>
//                             <div style={{ fontWeight: 700 }}>
//                                 {topShare}%
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         );
//     };

//     // Category Chart
//     const CategoryChart = () => {
//         const categoryData = useMemo(() => {
//             if (!stats?.topPerformingVendors?.length) return [];

//             // Use top performing vendors as categories
//             const colorsList = [
//                 "#6366f1",
//                 "#10b981",
//                 "#f59e0b",
//                 "#ef4444",
//                 "#8b5cf6",
//                 "#06b6d4"
//             ];

//             return stats.topPerformingVendors.map((vendor, index) => ({
//                 name: `Vendor ${vendor.vendorId}`,
//                 revenue: vendor.revenue || 0,
//                 percentage: parseFloat(vendor.percentage) || 0,
//                 color: colorsList[index % colorsList.length]
//             }));
//         }, [stats]);

//         if (loadingStats) return <div>Loading category chart...</div>;

//         if (!categoryData.length) {
//             return (
//                 <div style={{
//                     background: 'white',
//                     borderRadius: '24px',
//                     padding: '28px',
//                     marginBottom: '28px',
//                     border: '1px solid #e2e8f0',
//                     boxShadow: '0 12px 32px rgba(0,0,0,0.05)',
//                     textAlign: 'center'
//                 }}>
//                     <h3 style={{ fontWeight: 800, marginBottom: 20 }}>
//                         Vendor Performance
//                     </h3>
//                     <p style={{ color: '#64748b' }}>No vendor data available</p>
//                 </div>
//             );
//         }

//         return (
//             <div style={{
//                 background: 'white',
//                 borderRadius: '24px',
//                 padding: isMobile ? '20px' : '28px',
//                 marginBottom: isMobile ? '20px' : '28px',
//                 border: '1px solid #e2e8f0',
//                 boxShadow: '0 12px 32px rgba(0,0,0,0.05)'
//             }}>
//                 <h3 style={{ fontWeight: 800, marginBottom: 20 }}>
//                     Vendor Performance
//                 </h3>

//                 <div style={{ height: isMobile ? 260 : 400 }}>
//                     <ResponsiveContainer width="100%" height="100%">
//                         <PieChart>
//                             <Pie
//                                 data={categoryData}
//                                 cx="50%"
//                                 cy="50%"
//                                 innerRadius={isMobile ? 50 : 80}
//                                 outerRadius={isMobile ? 90 : 120}
//                                 paddingAngle={2}
//                                 dataKey="revenue"
//                                 nameKey="name"
//                                 label={(e) =>
//                                     `₹${e.revenue.toLocaleString("en-IN")} (${e.percentage}%)`
//                                 }
//                             >
//                                 {categoryData.map((entry, index) => (
//                                     <Cell
//                                         key={index}
//                                         fill={entry.color}
//                                         stroke="white"
//                                         strokeWidth={2}
//                                     />
//                                 ))}
//                             </Pie>

//                             <Tooltip
//                                 formatter={(v) =>
//                                     `₹${Number(v).toLocaleString("en-IN")}`
//                                 }
//                             />
//                             <Legend />
//                         </PieChart>
//                     </ResponsiveContainer>
//                 </div>
//             </div>
//         );
//     };

//     // Category Performance
//     const CategoryPerformance = () => {
//         const performanceData = useMemo(() => {
//             if (!stats?.topPerformingVendors?.length) return [];

//             return stats.topPerformingVendors.map(vendor => ({
//                 name: `Vendor ${vendor.vendorId}`,
//                 revenue: vendor.revenue || 0,
//                 percentage: parseFloat(vendor.percentage) || 0,
//                 growth: vendor.salesGrowth || "0%"
//             }));
//         }, [stats]);

//         if (loadingStats) return <div>Loading category performance...</div>;

//         if (!performanceData.length) {
//             return <div style={{ padding: 40, textAlign: 'center', color: '#64748b' }}>No vendor data available</div>;
//         }

//         const sorted = [...performanceData].sort((a, b) => b.revenue - a.revenue);
//         const bestPerforming = sorted[0];
//         const worstPerforming = sorted[sorted.length - 1];

//         return (
//             <div style={{
//                 background: 'white',
//                 borderRadius: '24px',
//                 padding: isMobile ? '20px' : '28px',
//                 marginBottom: '28px',
//                 border: '1px solid #e2e8f0',
//                 boxShadow: '0 12px 32px rgba(0,0,0,0.05)'
//             }}>
//                 <h3 style={{ fontWeight: 800, marginBottom: 24 }}>
//                     Vendor Leaders
//                 </h3>

//                 <div style={{
//                     display: 'grid',
//                     gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
//                     gap: '24px'
//                 }}>
//                     {/* ✅ BEST PERFORMER */}
//                     <div style={{
//                         background: '#ecfdf5',
//                         borderRadius: '20px',
//                         padding: '24px',
//                         border: '2px solid #bbf7d0'
//                     }}>
//                         <p style={{ fontSize: 12, fontWeight: 700, color: '#10b981' }}>
//                             TOP PERFORMER
//                         </p>

//                         <h4 style={{ fontSize: 22, fontWeight: 800, marginTop: 8 }}>
//                             {bestPerforming.name}
//                         </h4>

//                         <p style={{ marginTop: 16, fontSize: 18 }}>
//                             Revenue: <b>₹{bestPerforming.revenue.toLocaleString("en-IN")}</b>
//                         </p>

//                         <p style={{ fontSize: 16, color: '#10b981', fontWeight: 700 }}>
//                             {bestPerforming.percentage}% Market Share
//                         </p>
//                     </div>

//                     {/* ❌ LOWEST PERFORMER */}
//                     <div style={{
//                         background: '#fef2f2',
//                         borderRadius: '20px',
//                         padding: '24px',
//                         border: '2px solid #fecaca'
//                     }}>
//                         <p style={{ fontSize: 12, fontWeight: 700, color: '#ef4444' }}>
//                             NEEDS ATTENTION
//                         </p>

//                         <h4 style={{ fontSize: 22, fontWeight: 800, marginTop: 8 }}>
//                             {worstPerforming.name}
//                         </h4>

//                         <p style={{ marginTop: 16, fontSize: 18 }}>
//                             Revenue: <b>₹{worstPerforming.revenue.toLocaleString("en-IN")}</b>
//                         </p>

//                         <p style={{ fontSize: 16, color: '#ef4444', fontWeight: 700 }}>
//                             {worstPerforming.percentage}% Market Share
//                         </p>
//                     </div>
//                 </div>
//             </div>
//         );
//     };

//     // Item Table
//     const ItemTable = () => {
//         const itemData = useMemo(() => {
//             if (!stats?.topPerformingVendors?.length) return [];

//             return stats.topPerformingVendors.map((vendor, index) => {
//                 // Calculate derived metrics
//                 const orders = Math.round((stats.totalOrders * (vendor.percentage || 0)) / 100);
//                 const profit = vendor.revenue * 0.7; // Assuming 70% profit margin
//                 const profitMargin = 70; // Fixed for simplicity

//                 return {
//                     name: `Vendor ${vendor.vendorId}`,
//                     category: "Food Vendor",
//                     orders,
//                     revenue: vendor.revenue || 0,
//                     profit,
//                     profitMargin
//                 };
//             });
//         }, [stats]);

//         const [filter, setFilter] = useState("all");

//         if (loadingStats) return <div>Loading top items...</div>;

//         if (!itemData.length) {
//             return (
//                 <div style={{
//                     background: "white",
//                     borderRadius: "24px",
//                     padding: "28px",
//                     marginBottom: "28px",
//                     border: "1px solid #e2e8f0",
//                     boxShadow: "0 12px 32px rgba(0,0,0,0.06)",
//                     textAlign: 'center'
//                 }}>
//                     <h3 style={{ fontWeight: 800, marginBottom: 20 }}>
//                         Top Performing Vendors
//                     </h3>
//                     <p style={{ color: '#64748b' }}>No vendor data available</p>
//                 </div>
//             );
//         }

//         const filteredItems = filter === "all" 
//             ? itemData 
//             : itemData.filter(i => i.category === filter);

//         return (
//             <div
//                 style={{
//                     background: "white",
//                     borderRadius: "24px",
//                     padding: isMobile ? "20px" : "28px",
//                     marginBottom: "28px",
//                     border: "1px solid #e2e8f0",
//                     boxShadow: "0 12px 32px rgba(0,0,0,0.06)"
//                 }}
//             >
//                 {/* Header */}
//                 <div
//                     style={{
//                         display: "flex",
//                         justifyContent: "space-between",
//                         alignItems: isMobile ? "flex-start" : "center",
//                         flexDirection: isMobile ? "column" : "row",
//                         gap: "12px",
//                         marginBottom: "20px"
//                     }}
//                 >
//                     <div>
//                         <h3
//                             style={{
//                                 fontWeight: 800,
//                                 fontSize: isMobile ? "18px" : "22px",
//                                 color: "#1e293b",
//                                 marginBottom: "4px"
//                             }}
//                         >
//                             Top Performing Vendors
//                         </h3>
//                         <p
//                             style={{
//                                 fontSize: "14px",
//                                 color: "#64748b"
//                             }}
//                         >
//                             Best performing vendors by revenue
//                         </p>
//                     </div>

//                     {/* Filter */}
//                     <select
//                         value={filter}
//                         onChange={(e) => setFilter(e.target.value)}
//                         style={{
//                             padding: "10px 16px",
//                             borderRadius: "12px",
//                             border: "1px solid #e2e8f0",
//                             background: "#f8fafc",
//                             fontSize: "14px",
//                             fontWeight: 600,
//                             color: "#1e293b",
//                             cursor: "pointer",
//                             outline: "none",
//                             boxShadow: "0 2px 8px rgba(0,0,0,0.05)"
//                         }}
//                     >
//                         <option value="all">All Categories</option>
//                         {[...new Set(itemData.map(i => i.category))].map(cat => (
//                             <option key={cat} value={cat}>{cat}</option>
//                         ))}
//                     </select>
//                 </div>

//                 {/* Table */}
//                 <div
//                     style={{
//                         overflowX: "auto",
//                         borderRadius: "16px",
//                         border: "1px solid #e2e8f0"
//                     }}
//                 >
//                     <table
//                         style={{
//                             width: "100%",
//                             borderCollapse: "separate",
//                             borderSpacing: 0,
//                             minWidth: "750px",
//                             fontSize: "14px"
//                         }}
//                     >
//                         <thead>
//                             <tr
//                                 style={{
//                                     background: "#f8fafc",
//                                     position: "sticky",
//                                     top: 0,
//                                     zIndex: 1
//                                 }}
//                             >
//                                 {["Vendor", "Category", "Orders", "Revenue", "Profit", "Margin"].map(h => (
//                                     <th
//                                         key={h}
//                                         style={{
//                                             padding: "16px",
//                                             textAlign: "left",
//                                             fontSize: "12px",
//                                             fontWeight: 700,
//                                             color: "#475569",
//                                             borderBottom: "2px solid #e2e8f0",
//                                             letterSpacing: "0.4px",
//                                             textTransform: "uppercase"
//                                         }}
//                                     >
//                                         {h}
//                                     </th>
//                                 ))}
//                             </tr>
//                         </thead>

//                         <tbody>
//                             {filteredItems.map((item, idx) => (
//                                 <tr
//                                     key={idx}
//                                     style={{
//                                         background: idx % 2 === 0 ? "white" : "#f8fafc",
//                                         transition: "background 0.2s ease"
//                                     }}
//                                     onMouseEnter={e => e.currentTarget.style.background = "#eef2ff"}
//                                     onMouseLeave={e => e.currentTarget.style.background = idx % 2 === 0 ? "white" : "#f8fafc"}
//                                 >
//                                     <td style={{ padding: "16px", fontWeight: 600, color: "#1e293b" }}>
//                                         {item.name}
//                                     </td>

//                                     <td style={{ padding: "16px" }}>
//                                         <span
//                                             style={{
//                                                 padding: "6px 12px",
//                                                 background: "#f1f5f9",
//                                                 borderRadius: "10px",
//                                                 fontSize: "12px",
//                                                 fontWeight: 600,
//                                                 color: "#475569"
//                                             }}
//                                         >
//                                             {item.category}
//                                         </span>
//                                     </td>

//                                     <td style={{ padding: "16px", fontWeight: 700 }}>
//                                         {item.orders}
//                                     </td>

//                                     <td style={{ padding: "16px", fontWeight: 700 }}>
//                                         ₹{item.revenue.toLocaleString("en-IN")}
//                                     </td>

//                                     <td style={{ padding: "16px", fontWeight: 700 }}>
//                                         ₹{item.profit.toLocaleString("en-IN")}
//                                     </td>

//                                     <td style={{ padding: "16px" }}>
//                                         <span
//                                             style={{
//                                                 padding: "6px 16px",
//                                                 borderRadius: "20px",
//                                                 fontWeight: 700,
//                                                 fontSize: "13px",
//                                                 color:
//                                                     item.profitMargin > 40 ? "#10b981" :
//                                                         item.profitMargin > 20 ? "#d97706" :
//                                                             "#ef4444",
//                                                 background:
//                                                     item.profitMargin > 40 ? "#dcfce7" :
//                                                         item.profitMargin > 20 ? "#fef3c7" :
//                                                             "#fee2e2",
//                                                 border:
//                                                     item.profitMargin > 40 ? "1px solid #bbf7d0" :
//                                                         item.profitMargin > 20 ? "1px solid #fde68a" :
//                                                             "1px solid #fecaca"
//                                             }}
//                                         >
//                                             {item.profitMargin}%
//                                         </span>
//                                     </td>
//                                 </tr>
//                             ))}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>
//         );
//     };

//     // Payment Analysis
//     const PaymentAnalysis = () => {
//         const paymentData = useMemo(() => {
//             if (!stats?.paymentMethods?.length) return [];

//             const colorsList = [
//                 "#7c3aed",
//                 "#ec4899",
//                 "#22c55e",
//                 "#f59e0b",
//                 "#3b82f6"
//             ];

//             return stats.paymentMethods.map((method, index) => ({
//                 name: method.method.replace(/_/g, " "),
//                 amount: method.count || 0,
//                 percentage: parseFloat(method.percentage) || 0,
//                 color: colorsList[index % colorsList.length]
//             }));
//         }, [stats]);

//         if (loadingStats) return <div>Loading payment analysis...</div>;

//         if (!paymentData.length) {
//             return (
//                 <div style={{
//                     background: 'white',
//                     borderRadius: '24px',
//                     padding: '28px',
//                     marginBottom: '28px',
//                     border: '1px solid #e2e8f0',
//                     boxShadow: '0 12px 32px rgba(0,0,0,0.05)',
//                     textAlign: 'center'
//                 }}>
//                     <h3 style={{ fontWeight: 800, marginBottom: 20 }}>
//                         Payment Methods Analysis
//                     </h3>
//                     <p style={{ color: '#64748b' }}>No payment data available</p>
//                 </div>
//             );
//         }

//         return (
//             <div style={{
//                 background: 'white',
//                 borderRadius: '24px',
//                 padding: isMobile ? '20px' : '28px',
//                 marginBottom: '28px',
//                 border: '1px solid #e2e8f0',
//                 boxShadow: '0 12px 32px rgba(0,0,0,0.05)',
//                 position: 'relative',
//                 overflow: 'hidden'
//             }}>
//                 {/* Top Accent */}
//                 <div style={{
//                     position: 'absolute',
//                     top: 0,
//                     left: 0,
//                     right: 0,
//                     height: '4px',
//                     background: 'linear-gradient(90deg, #7c3aed, #ec4899)'
//                 }} />

//                 {/* Header */}
//                 <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '24px' }}>
//                     <div style={{
//                         width: '48px',
//                         height: '48px',
//                         borderRadius: '12px',
//                         background: 'linear-gradient(135deg, #7c3aed 0%, #ec4899 100%)',
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         color: 'white'
//                     }}>
//                         <CreditCard size={24} />
//                     </div>
//                     <div>
//                         <h3 style={{
//                             fontSize: isMobile ? '18px' : '22px',
//                             fontWeight: '800',
//                             color: '#1e293b'
//                         }}>
//                             Payment Methods Analysis
//                         </h3>
//                         <p style={{ color: '#64748b' }}>
//                             Order distribution by payment type
//                         </p>
//                     </div>
//                 </div>

//                 {/* Chart */}
//                 <div style={{ height: isMobile ? '280px' : '400px' }}>
//                     <ResponsiveContainer width="100%" height="100%">
//                         <BarChart data={paymentData}>
//                             <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" vertical={false} />
//                             <XAxis
//                                 dataKey="name"
//                                 axisLine={false}
//                                 tickLine={false}
//                             />
//                             <YAxis
//                                 axisLine={false}
//                                 tickLine={false}
//                             />
//                             <Tooltip
//                                 formatter={(v, name) => [
//                                     name === "amount" ? v : `${v}%`,
//                                     name === "amount" ? "Orders" : "Percentage"
//                                 ]}
//                             />
//                             <Bar
//                                 dataKey="amount"
//                                 name="Orders"
//                                 radius={[8, 8, 0, 0]}
//                                 label={{
//                                     position: "top",
//                                     fontWeight: "bold"
//                                 }}
//                             >
//                                 {paymentData.map((entry, index) => (
//                                     <Cell key={index} fill={entry.color} />
//                                 ))}
//                             </Bar>
//                         </BarChart>
//                     </ResponsiveContainer>
//                 </div>
//             </div>
//         );
//     };

//     // Gross Net Chart
//     const GrossNetChart = () => {
//         const chartData = useMemo(() => {
//             if (!stats) return [];

//             // Create weekly data based on total and today's revenue
//             const weeks = ["Week 1", "Week 2", "Week 3", "Week 4"];
//             return weeks.map((week, index) => {
//                 const baseGross = stats.totalRevenue || 0;
//                 const weekFactor = 0.2 + (index / 4) * 1.6; // Increasing trend
//                 const gross = Math.round((baseGross / 4) * weekFactor);
//                 const net = Math.round(gross * 0.85); // 15% expenses/discounts

//                 return {
//                     week,
//                     gross,
//                     net
//                 };
//             });
//         }, [stats]);

//         if (loadingStats) return <div>Loading gross vs net revenue...</div>;

//         if (!chartData.length) {
//             return (
//                 <div style={{
//                     background: 'white',
//                     borderRadius: '24px',
//                     padding: '28px',
//                     marginBottom: '28px',
//                     border: '1px solid #e2e8f0',
//                     boxShadow: '0 12px 32px rgba(0,0,0,0.05)',
//                     textAlign: 'center'
//                 }}>
//                     <h3 style={{ fontWeight: 800, marginBottom: 20 }}>
//                         Gross vs Net Revenue
//                     </h3>
//                     <p style={{ color: '#64748b' }}>No revenue data available</p>
//                 </div>
//             );
//         }

//         return (
//             <div style={{
//                 background: 'white',
//                 borderRadius: '24px',
//                 padding: isMobile ? '20px' : '28px',
//                 marginBottom: '28px',
//                 border: '1px solid #e2e8f0',
//                 boxShadow: '0 12px 32px rgba(0,0,0,0.05)',
//                 position: 'relative',
//                 overflow: 'hidden'
//             }}>
//                 {/* Top Accent */}
//                 <div style={{
//                     position: 'absolute',
//                     top: 0,
//                     left: 0,
//                     right: 0,
//                     height: '4px',
//                     background: 'linear-gradient(90deg, #3b82f6, #8b5cf6)'
//                 }} />

//                 {/* Header */}
//                 <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '24px' }}>
//                     <div style={{
//                         width: '48px',
//                         height: '48px',
//                         borderRadius: '12px',
//                         background: 'linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)',
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         color: 'white'
//                     }}>
//                         <Scale size={24} />
//                     </div>
//                     <div>
//                         <h3 style={{
//                             fontSize: isMobile ? '18px' : '22px',
//                             fontWeight: '800',
//                             color: '#1e293b'
//                         }}>
//                             Gross vs Net Revenue
//                         </h3>
//                         <p style={{ color: '#64748b' }}>
//                             Weekly revenue before and after expenses
//                         </p>
//                     </div>
//                 </div>

//                 {/* Chart */}
//                 <div style={{ height: isMobile ? '240px' : '360px' }}>
//                     <ResponsiveContainer width="100%" height="100%">
//                         <ComposedChart data={chartData}>
//                             <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" />
//                             <XAxis
//                                 dataKey="week"
//                                 axisLine={false}
//                                 tickLine={false}
//                             />
//                             <YAxis
//                                 tickFormatter={(v) => `₹${(v/1000).toFixed(0)}K`}
//                                 axisLine={false}
//                                 tickLine={false}
//                             />
//                             <Tooltip
//                                 formatter={(v) => `₹${Number(v).toLocaleString("en-IN")}`}
//                             />
//                             <Bar
//                                 dataKey="gross"
//                                 name="Gross Revenue"
//                                 fill={colors?.primary || "#3b82f6"}
//                                 radius={[8, 8, 0, 0]}
//                             />
//                             <Bar
//                                 dataKey="net"
//                                 name="Net Revenue"
//                                 fill={colors?.success || "#10b981"}
//                                 radius={[8, 8, 0, 0]}
//                             />
//                         </ComposedChart>
//                     </ResponsiveContainer>
//                 </div>
//             </div>
//         );
//     };

//     /* ---------------- ERROR DISPLAY ---------------- */

//     if (error && !stats) {
//         return (
//             <div style={{ 
//                 padding: "20px", 
//                 textAlign: "center", 
//                 color: "#ef4444",
//                 background: "#fef2f2",
//                 borderRadius: "12px",
//                 margin: "10px",
//                 border: "1px solid #fecaca"
//             }}>
//                 <h4 style={{ fontWeight: 600 }}>⚠️ API Connection Error</h4>
//                 <p>{error}</p>
//                 <p style={{ fontSize: "12px", color: "#64748b", marginTop: "10px" }}>
//                     Please check your internet connection and authentication.
//                 </p>
//             </div>
//         );
//     }

//     return (
//         <>
//             <SummaryCards />
//             <DateTrendChart />
//             <OrderTypeChart />
//             <CategoryChart />
//             <CategoryPerformance />
//             <ItemTable />
//             <PaymentAnalysis />
//             <GrossNetChart />
//         </>
//     );
// };

// export default Revenue;

















import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import {
    BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend,
    ResponsiveContainer, PieChart, Pie, Cell, LineChart, Line,
    ComposedChart, AreaChart, Area
} from "recharts";
import {
    TrendingUp, TrendingDown, DollarSign, ShoppingBag, Package,
    Users, CreditCard, CheckCircle, Calculator,
    Building, Tag, Truck, FileText, Utensils, Coffee, Pizza,
    Cake, ShoppingCart, CalendarIcon, Target,
    BarChart as BarChartIcon, PieChart as PieChartIcon,
    AlertCircle, Shield, Activity, Scale, Wallet, ChevronDown,
    Download, Filter, Sparkles, Crown, Trophy, TrendingUp as TrendUp,
    RotateCcw, Star, Clock, PackageOpen, UserCheck,
    MessageSquare, ThumbsUp, Award, CreditCard as CreditCardIcon,
    Star as StarIcon, Percent, DollarSign as DollarSignIcon,
    Pizza as PizzaIcon, ShoppingBag as ShoppingBagIcon,
    Cake as CakeIcon, Coffee as CoffeeIcon,
    Crown as CrownIcon, TrendingDown as TrendingDownIcon
} from 'lucide-react';

const Revenue = ({
    isMobile,
    colors,
    generateDateTrendData,
    generateOrderTypeData,
    generateCategoryData,
    generateTopItemsData,
    generatePaymentData,
    generateGrossNetData,
    generateDiscountImpactData,
    startDate,
    endDate,
    apiStats,
    customTotals,
    isCustomRangeActive,
    dateRangeData
}) => {

    /* ---------------- STATE ---------------- */
    const [stats, setStats] = useState(null);
    const [loadingStats, setLoadingStats] = useState(false);
    const [error, setError] = useState(null);

    /* ---------------- HELPER FUNCTIONS ---------------- */
    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
    };

    const parsePercentage = (percentString) => {
        if (!percentString) return 0;
        return parseFloat(percentString.replace('%', ''));
    };

    // Check if it's the default date range (last 30 days)
    const isDefaultRange = () => {
        if (!startDate || !endDate) return true;
        const defaultStart = new Date();
        defaultStart.setDate(defaultStart.getDate() - 30);
        const defaultStartStr = defaultStart.toISOString().split('T')[0];
        const todayStr = new Date().toISOString().split('T')[0];

        return startDate === defaultStartStr && endDate === todayStr;
    };

    // Calculate days difference
    const getDaysDifference = (start, end) => {
        if (!start || !end) return 0;
        const startDate = new Date(start);
        const endDate = new Date(end);
        const timeDiff = endDate.getTime() - startDate.getTime();
        return Math.floor(timeDiff / (1000 * 3600 * 24)) + 1;
    };

    // Format currency
    const formatCurrency = (amount) => {
        return `₹${Number(amount || 0).toLocaleString('en-IN', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        })}`;
    };

    /* ---------------- API CALLS ---------------- */
    useEffect(() => {
        const fetchRevenueData = async () => {
            setLoadingStats(true);
            setError(null);

            try {
                const token = localStorage.getItem("authToken");
                if (!token) {
                    throw new Error("No auth token found. Please login.");
                }

                const response = await axios.get(
                    "https://backend.maamaas.com/food/api/orders/admin/statistics",
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            Accept: "application/json",
                        },
                    }
                );

                const apiData = response.data || {};

                setStats(apiData);

            } catch (err) {
                console.error("❌ Revenue API error:", err);
                setError(err.message || "Failed to fetch revenue data");
                // Set default empty stats
                setStats({
                    totalRevenue: 0,
                    todayRevenue: 0,
                    totalOrders: 0,
                    todayTotalOrders: 0,
                    totalCustomers: 0,
                    todayCustomers: 0,
                    salesGrowth: "0%",
                    newCustomers: 0,
                    returningCustomers: 0,
                    topPerformingVendors: [],
                    paymentMethods: [],
                    totalCancelledOrders: 0,
                    todayCancelledOrders: 0,
                    todaySuccessRate: "0%"
                });
            } finally {
                setLoadingStats(false);
            }
        };

        fetchRevenueData();
    }, []);

    /* ---------------- CUSTOM RANGE DATA PROCESSING ---------------- */
    const processedData = useMemo(() => {
        const currentStats = apiStats || stats;

        if (isCustomRangeActive && customTotals) {
            // Use custom range data
            const daysDiff = getDaysDifference(startDate, endDate);
            const dailyAvgOrders = customTotals.orders / daysDiff;
            const dailyAvgRevenue = customTotals.revenue / daysDiff;

            // Generate date trend data for custom range
            const dateTrendData = [];
            const start = new Date(startDate);

            for (let i = 0; i < daysDiff; i++) {
                const currentDate = new Date(start);
                currentDate.setDate(start.getDate() + i);

                const variation = 0.8 + Math.random() * 0.4;
                const dailyRevenue = Math.round(dailyAvgRevenue * variation);
                const dailyOrders = Math.round(dailyAvgOrders * variation);
                const discount = dailyRevenue * (0.05 + Math.random() * 0.05);

                dateTrendData.push({
                    date: currentDate.toLocaleDateString('en-IN', { day: 'numeric', month: 'short' }),
                    label: currentDate.toLocaleDateString('en-IN', { day: 'numeric', month: 'short' }),
                    revenue: dailyRevenue,
                    netRevenue: Math.round(dailyRevenue - discount),
                    discount: Math.round(discount),
                    orders: dailyOrders,
                    fullDate: currentDate
                });
            }

            // Generate order type distribution based on custom totals
            const orderTypeData = [
                { name: 'Delivery', description: 'Home delivery', color: '#7c3aed', icon: <ShoppingCart size={16} /> },
                { name: 'Dine-in', description: 'In-restaurant dining', color: '#10b981', icon: <Utensils size={16} /> },
                { name: 'Takeaway', description: 'Pickup orders', color: '#3b82f6', icon: <ShoppingBag size={16} /> },
                { name: 'Catering', description: 'Event catering', color: '#f59e0b', icon: <Users size={16} /> }
            ].map(type => {
                let percentage;
                switch (type.name) {
                    case 'Delivery': percentage = 40; break;
                    case 'Dine-in': percentage = 35; break;
                    case 'Takeaway': percentage = 20; break;
                    default: percentage = 5; break;
                }
                const revenue = Math.round(customTotals.revenue * (percentage / 100));
                return {
                    ...type,
                    revenue,
                    percentage,
                    growth: (Math.random() > 0.5 ? 1 : -1) * (2 + Math.random() * 6)
                };
            });

            // Generate category data based on custom totals
            const categoryData = [
                { name: 'Main Course', description: 'Main dishes & curries', color: '#10b981', icon: <Utensils size={16} /> },
                { name: 'Biryani', description: 'Rice dishes', color: '#ef4444', icon: <Pizza size={16} /> },
                { name: 'Starters', description: 'Appetizers & snacks', color: '#f59e0b', icon: <PizzaIcon size={16} /> },
                { name: 'Fast Food', description: 'Burgers, pizzas, etc.', color: '#8b5cf6', icon: <ShoppingBagIcon size={16} /> },
                { name: 'Beverages', description: 'Drinks & beverages', color: '#3b82f6', icon: <CoffeeIcon size={16} /> },
                { name: 'Desserts', description: 'Sweets & desserts', color: '#ec4899', icon: <CakeIcon size={16} /> }
            ].map(category => {
                let percentage;
                switch (category.name) {
                    case 'Main Course': percentage = 35; break;
                    case 'Biryani': percentage = 25; break;
                    case 'Starters': percentage = 15; break;
                    case 'Fast Food': percentage = 10; break;
                    case 'Beverages': percentage = 10; break;
                    case 'Desserts': percentage = 5; break;
                    default: percentage = 0; break;
                }
                const revenue = Math.round(customTotals.revenue * (percentage / 100));
                return {
                    ...category,
                    revenue,
                    percentage,
                    growth: (Math.random() > 0.5 ? 1 : -1) * (3 + Math.random() * 8)
                };
            }).sort((a, b) => b.revenue - a.revenue);

            return {
                dateTrendData,
                orderTypeData,
                categoryData,
                summary: {
                    totalRevenue: customTotals.revenue,
                    totalOrders: customTotals.orders,
                    avgOrderValue: customTotals.revenue / customTotals.orders,
                    successRate: customTotals.avgRating ? ((customTotals.avgRating / 5) * 100).toFixed(1) + '%' : '85.0%',
                    isCustomRange: true
                }
            };
        } else {
            // Use default/generated data
            return {
                dateTrendData: generateDateTrendData || [],
                orderTypeData: generateOrderTypeData || [],
                categoryData: generateCategoryData || [],
                summary: {
                    totalRevenue: currentStats?.totalRevenue || 0,
                    totalOrders: currentStats?.totalOrders || 0,
                    avgOrderValue: currentStats?.totalOrders > 0 ?
                        (currentStats.totalRevenue || 0) / currentStats.totalOrders : 0,
                    successRate: currentStats?.todaySuccessRate || '85.0%',
                    isCustomRange: false
                }
            };
        }
    }, [apiStats, stats, isCustomRangeActive, customTotals, startDate, endDate,
        generateDateTrendData, generateOrderTypeData, generateCategoryData]);

    // Summary Cards Component - Updated to use CUSTOM RANGE data when active
    const SummaryCards = () => {
        const { summary } = processedData;
        const currentStats = apiStats || stats;

        const cards = [
            {
                title: isCustomRangeActive ? 'Custom Range Revenue' : 'Total Revenue',
                value: formatCurrency(summary.totalRevenue),
                icon: <span style={{ fontSize: '18px', fontWeight: '700' }}>₹</span>,
                color: colors?.success || "#10b981",
                bgColor: 'linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%)',
                subtitle: isCustomRangeActive
                    ? `${formatDate(startDate)} - ${formatDate(endDate)}`
                    : `${summary.totalOrders.toLocaleString('en-IN')} total orders`
            },
            {
                title: "Total Orders",
                value: summary.totalOrders.toLocaleString('en-IN'),
                icon: <ShoppingBag size={isMobile ? 16 : 18} />,
                color: colors?.primary || "#3b82f6",
                bgColor: 'linear-gradient(135deg, #ede9fe 0%, #ddd6fe 100%)',
                subtitle: isCustomRangeActive
                    ? `${getDaysDifference(startDate, endDate)} days`
                    : `${currentStats?.totalCustomers || 0} customers`
            },
            {
                title: 'Avg Order Value',
                value: `₹${Math.round(summary.avgOrderValue).toLocaleString('en-IN')}`,
                icon: <Target size={isMobile ? 16 : 18} />,
                color: colors?.accent || "#f59e0b",
                bgColor: 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)',
                subtitle: `Growth: ${currentStats?.salesGrowth || "0%"}`
            },
            {
                title: 'Success Rate',
                value: summary.successRate,
                icon: <CheckCircle size={isMobile ? 16 : 18} />,
                color: colors?.info || "#8b5cf6",
                bgColor: 'linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%)',
                subtitle: isCustomRangeActive
                    ? 'Custom range completion'
                    : `${currentStats?.newCustomers || 0} new customers`
            }
        ];

        if (loadingStats) {
            return (
                <div style={{ padding: 20, textAlign: "center", color: "#64748b" }}>
                    Loading revenue summary...
                </div>
            );
        }

        if (error && !currentStats) {
            return (
                <div style={{
                    padding: "20px",
                    textAlign: "center",
                    color: "#ef4444",
                    background: "#fef2f2",
                    borderRadius: "12px",
                    marginBottom: "20px"
                }}>
                    <h4 style={{ fontWeight: 600 }}>⚠️ Error Loading Data</h4>
                    <p>{error}</p>
                </div>
            );
        }

        return (
            <div
                style={{
                    display: 'grid',
                    gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)',
                    gap: isMobile ? '8px' : '12px',
                    marginBottom: isMobile ? '16px' : '20px',
                    marginTop: isMobile ? '-5px' : '-28px',
                }}
            >
                {cards.map((card, index) => (
                    <div
                        key={index}
                        style={{
                            background: card.bgColor,
                            borderRadius: '12px',
                            padding: isMobile ? '12px' : '16px',
                            boxShadow: '0 4px 12px rgba(0,0,0,0.04)',
                            border: '1px solid white',
                            position: 'relative'
                        }}
                    >
                        <p
                            style={{
                                fontSize: isMobile ? '10px' : '11px',
                                color: '#475569',
                                fontWeight: '600'
                            }}
                        >
                            {card.title}
                        </p>

                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center'
                            }}
                        >
                            <div>
                                <p
                                    style={{
                                        fontSize: isMobile ? '16px' : '20px',
                                        fontWeight: '800',
                                        color: '#1e293b',
                                        marginBottom: '4px'
                                    }}
                                >
                                    {card.value}
                                </p>
                                {card.subtitle && (
                                    <p style={{ fontSize: 10, color: "#64748b", margin: 0 }}>
                                        {card.subtitle}
                                    </p>
                                )}
                            </div>

                            <div
                                style={{
                                    width: isMobile ? '32px' : '40px',
                                    height: isMobile ? '32px' : '40px',
                                    borderRadius: '10px',
                                    background: 'rgba(255,255,255,0.6)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: card.color
                                }}
                            >
                                {card.icon}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        );
    };

    // Date Trend Chart - UPDATED to use processed data
    const DateTrendChart = () => {
        const { dateTrendData } = processedData;

        if (loadingStats) return <div>Loading trend chart...</div>;

        const chartTitle = isCustomRangeActive && startDate && endDate
            ? `Revenue Trend: ${formatDate(startDate)} - ${formatDate(endDate)}`
            : "Revenue Trend";

        return (
            <div style={{
                background: 'white',
                borderRadius: '24px',
                padding: isMobile ? '20px' : '28px',
                marginBottom: isMobile ? '20px' : '28px',
                border: '1px solid #e2e8f0',
                boxShadow: '0 12px 32px rgba(0,0,0,0.05)'
            }}>
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '20px'
                }}>
                    <h3 style={{ fontWeight: 800, margin: 0 }}>
                        {chartTitle}
                    </h3>
                    {isCustomRangeActive && (
                        <span style={{
                            background: '#f8fafc',
                            padding: '6px 12px',
                            borderRadius: '8px',
                            fontSize: '12px',
                            color: '#64748b',
                            border: '1px solid #e2e8f0',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px'
                        }}>
                            <CalendarIcon size={12} />
                            Custom Range
                        </span>
                    )}
                </div>
                <ResponsiveContainer width="100%" height={300}>
                    <LineChart data={dateTrendData}>
                        <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" />
                        <XAxis
                            dataKey="date"
                            tick={{ fontSize: 12 }}
                        />
                        <YAxis
                            tickFormatter={(v) => `₹${(v / 1000).toFixed(0)}K`}
                            tick={{ fontSize: 12 }}
                        />
                        <Tooltip
                            formatter={(v) => [`₹${Number(v).toLocaleString("en-IN")}`, "Revenue"]}
                            labelFormatter={(label) => `Date: ${label}`}
                        />
                        <Legend />
                        <Line
                            dataKey="revenue"
                            name="Revenue"
                            stroke={colors?.primary || "#3b82f6"}
                            strokeWidth={2}
                            dot={{ r: 4 }}
                        />
                        <Line
                            dataKey="netRevenue"
                            name="Net Revenue"
                            stroke={colors?.success || "#10b981"}
                            strokeWidth={2}
                            dot={{ r: 4 }}
                        />
                    </LineChart>
                </ResponsiveContainer>
            </div>
        );
    };

    // Order Type Chart - UPDATED to use processed data
    const OrderTypeChart = () => {
        const { orderTypeData } = processedData;

        if (loadingStats) return <div>Loading order type chart...</div>;

        return (
            <div style={{
                background: 'white',
                borderRadius: '24px',
                padding: isMobile ? '20px' : '28px',
                marginBottom: isMobile ? '20px' : '28px',
                border: '1px solid #e2e8f0',
                boxShadow: '0 12px 32px rgba(0,0,0,0.05)',
                position: 'relative'
            }}>
                <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    height: '4px',
                    background: 'linear-gradient(135deg, #6366f1, #3b82f6)'
                }} />

                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 24 }}>
                    <div style={{ display: 'flex', gap: 12 }}>
                        <div style={{
                            width: 48,
                            height: 48,
                            borderRadius: 12,
                            background: 'linear-gradient(135deg, #6366f1, #3b82f6)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: '#fff'
                        }}>
                            <ShoppingBag size={24} />
                        </div>
                        <div>
                            <h3 style={{ fontSize: isMobile ? 18 : 22, fontWeight: 800 }}>
                                Order Type Distribution
                            </h3>
                            <p style={{ color: '#64748b' }}>
                                {isCustomRangeActive ? 'Custom range revenue breakdown' : 'Revenue breakdown by order type'}
                            </p>
                        </div>
                    </div>
                    {isCustomRangeActive && (
                        <div style={{
                            background: '#f8fafc',
                            padding: '6px 12px',
                            borderRadius: '8px',
                            fontSize: '12px',
                            color: '#64748b',
                            border: '1px solid #e2e8f0'
                        }}>
                            {getDaysDifference(startDate, endDate)} days
                        </div>
                    )}
                </div>

                <div style={{ height: isMobile ? 280 : 400 }}>
                    <ResponsiveContainer width="100%" height="100%">
                        <BarChart data={orderTypeData}>
                            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f1f5f9" />
                            <XAxis dataKey="name" tick={{ fontSize: 12 }} />
                            <YAxis
                                tickFormatter={(v) => `₹${(v / 1000).toFixed(0)}K`}
                                tick={{ fontSize: 12 }}
                            />
                            <Tooltip
                                formatter={(v) => [`₹${Number(v).toLocaleString('en-IN')}`, "Revenue"]}
                            />
                            <Legend />
                            <Bar dataKey="revenue" name="Revenue" radius={[8, 8, 0, 0]}>
                                {orderTypeData.map((entry, i) => (
                                    <Cell key={i} fill={entry.color} />
                                ))}
                            </Bar>
                        </BarChart>
                    </ResponsiveContainer>
                </div>

                <div style={{
                    marginTop: 20,
                    padding: 16,
                    background: '#f8fafc',
                    borderRadius: 16,
                    border: '1px solid #e2e8f0'
                }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: '10px' }}>
                        <div>
                            <div style={{ fontSize: 12, color: '#64748b' }}>Total Revenue</div>
                            <div style={{ fontSize: isMobile ? 16 : 20, fontWeight: 800 }}>
                                ₹{orderTypeData.reduce((sum, item) => sum + (item.revenue || 0), 0).toLocaleString('en-IN')}
                            </div>
                        </div>
                        <div>
                            <div style={{ fontSize: 12, color: '#64748b' }}>Most Popular</div>
                            <div style={{ fontWeight: 700 }}>
                                {orderTypeData.length > 0 ? orderTypeData.reduce((a, b) => (a.revenue > b.revenue ? a : b)).name : 'N/A'}
                            </div>
                        </div>
                        <div>
                            <div style={{ fontSize: 12, color: '#64748b' }}>Top Share</div>
                            <div style={{ fontWeight: 700 }}>
                                {orderTypeData.length > 0 ? Math.max(...orderTypeData.map(i => i.percentage || 0)).toFixed(1) + '%' : '0%'}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    // Category Chart - UPDATED to use processed data
    const CategoryChart = () => {
        const { categoryData } = processedData;

        if (loadingStats) return <div>Loading category chart...</div>;

        if (!categoryData.length) {
            return (
                <div style={{
                    background: 'white',
                    borderRadius: '24px',
                    padding: '28px',
                    marginBottom: '28px',
                    border: '1px solid #e2e8f0',
                    boxShadow: '0 12px 32px rgba(0,0,0,0.05)',
                    textAlign: 'center'
                }}>
                    <h3 style={{ fontWeight: 800, marginBottom: 20 }}>
                        Category Performance
                    </h3>
                    <p style={{ color: '#64748b' }}>No category data available</p>
                </div>
            );
        }

        return (
            <div style={{
                background: 'white',
                borderRadius: '24px',
                padding: isMobile ? '20px' : '28px',
                marginBottom: isMobile ? '20px' : '28px',
                border: '1px solid #e2e8f0',
                boxShadow: '0 12px 32px rgba(0,0,0,0.05)'
            }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
                    <h3 style={{ fontWeight: 800, margin: 0 }}>
                        Category Performance
                    </h3>
                    {isCustomRangeActive && (
                        <div style={{
                            background: '#f8fafc',
                            padding: '6px 12px',
                            borderRadius: '8px',
                            fontSize: '12px',
                            color: '#64748b'
                        }}>
                            {categoryData.length} categories
                        </div>
                    )}
                </div>

                <div style={{ height: isMobile ? 260 : 400 }}>
                    <ResponsiveContainer width="100%" height="100%">
                        <PieChart>
                            <Pie
                                data={categoryData}
                                cx="50%"
                                cy="50%"
                                innerRadius={isMobile ? 50 : 80}
                                outerRadius={isMobile ? 90 : 120}
                                paddingAngle={2}
                                dataKey="revenue"
                                nameKey="name"
                                label={(e) =>
                                    `₹${e.revenue.toLocaleString("en-IN")} (${e.percentage}%)`
                                }
                            >
                                {categoryData.map((entry, index) => (
                                    <Cell
                                        key={index}
                                        fill={entry.color}
                                        stroke="white"
                                        strokeWidth={2}
                                    />
                                ))}
                            </Pie>

                            <Tooltip
                                formatter={(v) =>
                                    `₹${Number(v).toLocaleString("en-IN")}`
                                }
                            />
                            <Legend />
                        </PieChart>
                    </ResponsiveContainer>
                </div>
            </div>
        );
    };

    // Category Performance - UPDATED to use processed data
    const CategoryPerformance = () => {
        const { categoryData } = processedData;

        if (loadingStats) return <div>Loading category performance...</div>;

        if (!categoryData.length) {
            return <div style={{ padding: 40, textAlign: 'center', color: '#64748b' }}>No category data available</div>;
        }

        const sorted = [...categoryData].sort((a, b) => b.revenue - a.revenue);
        const bestPerforming = sorted[0];
        const worstPerforming = sorted[sorted.length - 1];

        return (
            <div style={{
                background: 'white',
                borderRadius: '24px',
                padding: isMobile ? '20px' : '28px',
                marginBottom: '28px',
                border: '1px solid #e2e8f0',
                boxShadow: '0 12px 32px rgba(0,0,0,0.05)'
            }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
                    <h3 style={{ fontWeight: 800, margin: 0 }}>
                        Category Leaders
                    </h3>
                    {isCustomRangeActive && (
                        <div style={{
                            background: '#f8fafc',
                            padding: '6px 12px',
                            borderRadius: '8px',
                            fontSize: '12px',
                            color: '#64748b'
                        }}>
                            Custom Range
                        </div>
                    )}
                </div>

                <div style={{
                    display: 'grid',
                    gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
                    gap: '24px'
                }}>
                    <div style={{
                        background: '#ecfdf5',
                        borderRadius: '20px',
                        padding: '24px',
                        border: '2px solid #bbf7d0'
                    }}>
                        <p style={{ fontSize: 12, fontWeight: 700, color: '#10b981' }}>
                            TOP PERFORMER
                        </p>

                        <h4 style={{ fontSize: 22, fontWeight: 800, marginTop: 8 }}>
                            {bestPerforming.name}
                        </h4>

                        <p style={{ marginTop: 16, fontSize: 18 }}>
                            Revenue: <b>₹{bestPerforming.revenue.toLocaleString("en-IN")}</b>
                        </p>

                        <p style={{ fontSize: 16, color: '#10b981', fontWeight: 700 }}>
                            {bestPerforming.percentage}% Market Share
                        </p>
                    </div>

                    <div style={{
                        background: '#fef2f2',
                        borderRadius: '20px',
                        padding: '24px',
                        border: '2px solid #fecaca'
                    }}>
                        <p style={{ fontSize: 12, fontWeight: 700, color: '#ef4444' }}>
                            NEEDS ATTENTION
                        </p>

                        <h4 style={{ fontSize: 22, fontWeight: 800, marginTop: 8 }}>
                            {worstPerforming.name}
                        </h4>

                        <p style={{ marginTop: 16, fontSize: 18 }}>
                            Revenue: <b>₹{worstPerforming.revenue.toLocaleString("en-IN")}</b>
                        </p>

                        <p style={{ fontSize: 16, color: '#ef4444', fontWeight: 700 }}>
                            {worstPerforming.percentage}% Market Share
                        </p>
                    </div>
                </div>
            </div>
        );
    };

    // Top Vendors Performance - Based on API data
    const TopVendorsPerformance = () => {
        const currentStats = apiStats || stats;

        if (!currentStats?.topPerformingVendors?.length) {
            return null;
        }

        const topVendors = currentStats.topPerformingVendors.slice(0, 5);

        return (
            <div style={{
                background: 'white',
                borderRadius: '24px',
                padding: isMobile ? '20px' : '28px',
                marginBottom: isMobile ? '20px' : '28px',
                border: '1px solid #e2e8f0',
                boxShadow: '0 12px 32px rgba(0,0,0,0.05)',
                position: 'relative'
            }}>
                <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    height: '4px',
                    background: 'linear-gradient(135deg, #7c3aed, #ec4899)'
                }} />

                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '24px' }}>
                    <div style={{
                        width: '48px',
                        height: '48px',
                        borderRadius: '12px',
                        background: 'linear-gradient(135deg, #7c3aed 0%, #ec4899 100%)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: 'white'
                    }}>
                        <CrownIcon size={24} />
                    </div>
                    <div>
                        <h3 style={{
                            fontSize: isMobile ? '18px' : '22px',
                            fontWeight: '800',
                            color: '#1e293b'
                        }}>
                            Top Performing Vendors
                        </h3>
                        <p style={{ color: '#64748b' }}>
                            Based on total revenue contribution
                        </p>
                    </div>
                </div>

                <div style={{ display: 'grid', gap: '16px' }}>
                    {topVendors.map((vendor, index) => {
                        const percentage = parsePercentage(vendor.percentage);
                        const revenue = vendor.revenue || 0;
                        const isTop = index === 0;

                        return (
                            <div
                                key={vendor.vendorId}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    padding: '16px',
                                    background: isTop ? '#faf5ff' : '#f8fafc',
                                    borderRadius: '16px',
                                    border: `2px solid ${isTop ? '#8b5cf6' : '#e2e8f0'}`,
                                    transition: 'all 0.3s ease'
                                }}
                            >
                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                    <div style={{
                                        width: '40px',
                                        height: '40px',
                                        borderRadius: '10px',
                                        background: isTop ? 'linear-gradient(135deg, #8b5cf6, #7c3aed)' : '#e2e8f0',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        color: isTop ? 'white' : '#64748b',
                                        fontWeight: '700'
                                    }}>
                                        {isTop ? <CrownIcon size={16} /> : `#${index + 1}`}
                                    </div>
                                    <div>
                                        <h4 style={{
                                            fontSize: '16px',
                                            fontWeight: '700',
                                            color: '#1e293b',
                                            margin: 0
                                        }}>
                                            Vendor {vendor.vendorId}
                                        </h4>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '4px' }}>
                                            {parseFloat(vendor.salesGrowth) > 0 ? (
                                                <TrendingUp size={12} color="#10b981" />
                                            ) : parseFloat(vendor.salesGrowth) < 0 ? (
                                                <TrendingDownIcon size={12} color="#ef4444" />
                                            ) : (
                                                <span style={{ color: '#94a3b8' }}>—</span>
                                            )}
                                            <span style={{
                                                fontSize: '12px',
                                                color: parseFloat(vendor.salesGrowth) > 0 ? '#10b981' :
                                                    parseFloat(vendor.salesGrowth) < 0 ? '#ef4444' : '#64748b',
                                                fontWeight: '600'
                                            }}>
                                                {vendor.salesGrowth}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div style={{ textAlign: 'right' }}>
                                    <div style={{
                                        fontSize: '18px',
                                        fontWeight: '800',
                                        color: '#1e293b',
                                        marginBottom: '4px'
                                    }}>
                                        {formatCurrency(revenue)}
                                    </div>
                                    {/* <div style={{
                                        padding: '4px 12px',
                                        background: isTop ? '#ede9fe' : '#f1f5f9',
                                        borderRadius: '20px',
                                        fontSize: '12px',
                                        fontWeight: '700',
                                        color: isTop ? '#7c3aed' : '#475569'
                                    }}>
                                        {percentage.toFixed(2)}%
                                    </div> */}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    };

    // Payment Methods Chart - Based on API data
    const PaymentMethodsChart = () => {
        const currentStats = apiStats || stats;

        if (!currentStats?.paymentMethods?.length) {
            return null;
        }

        const paymentData = currentStats.paymentMethods.map(method => ({
            name: method.method.replace('_', ' '),
            value: parsePercentage(method.percentage),
            count: method.count || 0,
            color: method.method === 'Cash' ? '#10b981' :
                method.method === 'Online_Payment' ? '#3b82f6' :
                    '#8b5cf6'
        }));

        const totalTransactions = paymentData.reduce((sum, method) => sum + method.count, 0);

        return (
            <div style={{
                background: 'white',
                borderRadius: '24px',
                padding: isMobile ? '20px' : '28px',
                marginBottom: isMobile ? '20px' : '28px',
                border: '1px solid #e2e8f0',
                boxShadow: '0 12px 32px rgba(0,0,0,0.05)',
                position: 'relative'
            }}>
                <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    height: '4px',
                    background: 'linear-gradient(135deg, #10b981, #3b82f6)'
                }} />

                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '24px' }}>
                    <div style={{
                        width: '48px',
                        height: '48px',
                        borderRadius: '12px',
                        background: 'linear-gradient(135deg, #10b981 0%, #3b82f6 100%)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: 'white'
                    }}>
                        <CreditCard size={24} />
                    </div>
                    <div>
                        <h3 style={{
                            fontSize: isMobile ? '18px' : '22px',
                            fontWeight: '800',
                            color: '#1e293b'
                        }}>
                            Payment Methods
                        </h3>
                        <p style={{ color: '#64748b' }}>
                            Transaction distribution by payment type
                        </p>
                    </div>
                </div>

                <div style={{ height: isMobile ? '250px' : '300px' }}>
                    <ResponsiveContainer width="100%" height="100%">
                        <PieChart>
                            <Pie
                                data={paymentData}
                                cx="50%"
                                cy="50%"
                                innerRadius={isMobile ? 60 : 80}
                                outerRadius={isMobile ? 100 : 120}
                                paddingAngle={2}
                                dataKey="value"
                                nameKey="name"
                                label={(entry) => `${entry.name}: ${entry.value.toFixed(2)}%`}
                            >
                                {paymentData.map((entry, index) => (
                                    <Cell key={index} fill={entry.color} stroke="white" strokeWidth={2} />
                                ))}
                            </Pie>
                            <Tooltip
                                formatter={(value, name) => [`${value.toFixed(2)}%`, name]}
                            />
                            <Legend />
                        </PieChart>
                    </ResponsiveContainer>
                </div>
            </div>
        );
    };

    /* ---------------- ERROR DISPLAY ---------------- */
    if (error && !stats) {
        return (
            <div style={{
                padding: "20px",
                textAlign: "center",
                color: "#ef4444",
                background: "#fef2f2",
                borderRadius: "12px",
                margin: "10px",
                border: "1px solid #fecaca"
            }}>
                <h4 style={{ fontWeight: 600 }}>⚠️ API Connection Error</h4>
                <p>{error}</p>
                <p style={{ fontSize: "12px", color: "#64748b", marginTop: "10px" }}>
                    Please check your internet connection and authentication.
                </p>
            </div>
        );
    }

    return (
        <>
            <SummaryCards />
            <DateTrendChart />
            <TopVendorsPerformance />
            <PaymentMethodsChart />
            <OrderTypeChart />
            {/* <CategoryChart />
            <CategoryPerformance /> */}
        </>
    );
};

export default Revenue;